import { Box } from "@bcc-ui/ui-components";
import classNames from "classnames";
import React from "react";

import style from "./highlighted-label.scss";

interface Props {
    children: React.ReactNode;
    className?: string;
    testId?: string;
    dataType?: string;
}

export const HighlightedLabel = (props: Props) => {
    return (
        <Box
            paddingTop={"Xxs"}
            paddingBottom={"Xxs"}
            paddingLeft={"Sm"}
            paddingRight={"Xs"}
            verticalAlignment={"Center"}
            justifyContent={"SpaceBetween"}
            className={classNames(style.highlightedLabel, props.className)}
            testId={props.testId}
            datatype={props.dataType}
        >
            {props.children}
        </Box>
    );
};
